import React, { useState } from 'react';
import { FaseCategoriaTorneio } from '../../../services/categoriaTorneioService';
import PhaseRow from './PhaseRow';

export interface PhaseTableProps {
  phases: FaseCategoriaTorneio[];
  onCreate: () => void;
  onEdit: (fase: FaseCategoriaTorneio) => void;
  onDelete: (fase: FaseCategoriaTorneio) => void;
  onReorder: (fases: FaseCategoriaTorneio[]) => void;
}

const PhaseTable: React.FC<PhaseTableProps> = ({ phases, onCreate, onEdit, onDelete, onReorder }) => {
  const [draggingId, setDraggingId] = useState<string | null>(null);

  const handleDragStart = (id: string) => {
    setDraggingId(id);
  };

  const handleDrop = (overId: string) => {
    if (!draggingId || draggingId === overId) return;
    const items = [...phases];
    const draggedIndex = items.findIndex((f) => f.id === draggingId);
    const overIndex = items.findIndex((f) => f.id === overId);
    const [removed] = items.splice(draggedIndex, 1);
    items.splice(overIndex, 0, removed);
    const reordered = items.map((f, idx) => ({ ...f, ordem: idx + 1 }));
    onReorder(reordered);
    setDraggingId(null);
  };

  return (
    <div className="mt-4">
      <div className="d-flex justify-content-between align-items-center mb-2">
        <h5 className="mb-0">Fases da Categoria</h5>
        <button className="btn btn-primary" onClick={onCreate}>Nova fase +</button>
      </div>
      {phases.length === 0 ? (
        <div className="card p-3 text-center">
          <p className="mb-2">Nenhuma fase cadastrada</p>
          <button className="btn btn-primary" onClick={onCreate}>Nova fase +</button>
        </div>
      ) : (
        <table className="table">
          <thead>
            <tr>
              <th>Nome</th>
              <th>Período</th>
              <th>Status</th>
              <th>Ordem</th>
              <th>Ações</th>
            </tr>
          </thead>
          <tbody>
            {phases.sort((a, b) => a.ordem - b.ordem).map((fase) => (
              <PhaseRow
                key={fase.id}
                phase={fase}
                onEdit={onEdit}
                onDelete={onDelete}
                onDragStart={handleDragStart}
                onDragOver={(_id) => {}}
                onDrop={() => handleDrop(fase.id)}
              />
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
};

export default PhaseTable;
